export const fullstory = {
  org: `${process.env.REACT_APP_FULLSTORY_ORG}`,
  debug: process.env.NODE_ENV === 'development'
};